<script>
    export default {
		name: 'bg-image-css',
		props: {
      headCss : {
        type: String
      }
    },
  	mounted() {
			if (typeof(window.scCssVue) == 'undefined' )
			{
				window.scCssVue = this.headCss;
			}
			else
			{
				window.scCssVue = window.scCssVue + this.headCss;
			}

			if (typeof(scCssVue) != 'undefined') 
			{

	      let head = document.head || document.getElementsByTagName('head')[0],
	          style = document.createElement('style');

	      style.type = 'text/css';
	      if (style.styleSheet){
	        style.styleSheet.cssText = scCssVue;
	      } 
	      else 
	      {
	        style.appendChild(document.createTextNode(scCssVue));
	      }

	      head.appendChild(style);
	    }
  	}
	}
</script>



// WEBPACK FOOTER //
// bg-image-css.vue?5721e1e8